// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles spécifiques pour le menu d'actions */
.tableau-section .action-menu-container {
  position: relative;
}

.tableau-section .action-options-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  padding: 8px 0;
  margin-top: 8px;
}

.tableau-section .action-option {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: 10px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #484848;
  white-space: nowrap;
}

.tableau-section .action-option:hover {
  background-color: #f3f4f6;
}

.tableau-section .option-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableau-section .option-icon svg {
  width: 16px;
  height: 16px;
  color: #484848;
}
`, "",{"version":3,"sources":["webpack://./src/composants/GestionComptes/menu-actions.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":["/* Styles spécifiques pour le menu d'actions */\n.tableau-section .action-menu-container {\n  position: relative;\n}\n\n.tableau-section .action-options-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  min-width: 200px;\n  padding: 8px 0;\n  margin-top: 8px;\n}\n\n.tableau-section .action-option {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  text-align: left;\n  padding: 10px 16px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #484848;\n  white-space: nowrap;\n}\n\n.tableau-section .action-option:hover {\n  background-color: #f3f4f6;\n}\n\n.tableau-section .option-icon {\n  margin-right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tableau-section .option-icon svg {\n  width: 16px;\n  height: 16px;\n  color: #484848;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
